/**
 * DisplaySettingsContext オブジェクトと useDisplaySettings フック
 *
 * @file useDisplaySettings.ts
 * @version 1.0.0
 * @author Japan4U Development Team
 * @summary
 * DisplaySettings context オブジェクトと useDisplaySettings フックを提供する。
 * DisplaySettingsContext.tsx から分離し Fast Refresh 互換を確保。
 */

import { createContext, useContext } from 'react';
import type { DisplaySettings } from './displaySettingsSnapshot';

export const DisplaySettingsContext = createContext<DisplaySettings | null>(null);

export const useDisplaySettings = (): DisplaySettings => {
  const ctx = useContext(DisplaySettingsContext);
  if (!ctx) {
    throw new Error('[useDisplaySettings] DisplaySettingsProvider の外で呼び出されました。');
  }
  return ctx;
};
